import React from 'react';
import styled from 'styled-components';
import {StyledProps, mediaQueries} from '../../modules/common';
import {H2, H3} from '../headings';

interface Props extends StyledProps {
    children: React.ReactNode;
}

const UnstyledCommonTitle = (props: Props): JSX.Element => {
    const {className, children} = props;
    return (
        <H2 $centered={false} className={className}>
            {children}
        </H2>
    );
};

const CommonTitle = styled(UnstyledCommonTitle)`
    margin: 48px 0 24px;
    padding: 8px 0;
    ${mediaQueries.lessThan('small')`
        font-size: ${(props): string =>
            `${props.theme.fontSizes.large}${props.theme.unitsOfMeasure.px}`}
    `};
    
`;

export const TeloaCommonTitle = styled(UnstyledCommonTitle)`
    margin: 48px 0 24px;
    padding: 8px 0;
    ${mediaQueries.lessThan('small')`
        font-size: 32px;
    `};
    
`;

const UnstyledCommonSubTitle = (props: Props): JSX.Element => {
    const {className, children} = props;
    return (
        <H3 $centered={false} className={className}>
            {children}
        </H3>
    );
};

const CommonSubTitle = styled(UnstyledCommonSubTitle)`
    margin: 8px 0;
    ${mediaQueries.lessThan('small')`
        font-size: ${(props): string =>
            `${props.theme.fontSizes.medium}${props.theme.unitsOfMeasure.px}`}
    `};
`;

export const TeloaCommonSubTitle = styled(UnstyledCommonSubTitle)`
    margin: 8px 0;
    ${mediaQueries.lessThan('small')`
        font-size: 24px;
    `};
`;

export {CommonTitle, CommonSubTitle};
